import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { isEmpty, isUndefined } from "lodash";
import { useAppSelector } from "redux/hooks";

const Disclaimer = (props: any) => {
  const { open, setOpen } = props;
  const disclaimer = useAppSelector((state) => state.PrivacyAndDisclaimer.privacyAndDisclaimer);
  const result: any =
    !isEmpty(disclaimer) &&
    Object.values(disclaimer)?.length &&
    Object.values(disclaimer).find((item: any) => item.type === "franchise_disclaimer");
  return (
    <>
      {!isUndefined(result.content) && (
        <DialogFormation
          openDialog={open}
          title="Franchise Disclaimer"
          handleClose={() => setOpen(false)}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button onClick={() => setOpen(false)} label={"Close"}></Button>
            </div>
          }
        >
          {result.content && <div dangerouslySetInnerHTML={{ __html: result.content }}></div>}
        </DialogFormation>
      )}
    </>
  );
};

export default Disclaimer;
